import React, { useEffect } from "react";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { CMSPath } from "../../../config/constant";
import { scrollToTop } from "../../../JS/scrollToTop";

const SpaBookingSuccess = (props) => {
  const { t } = props;

  useEffect(()=>{

    scrollToTop()
  },[])

  return (
    <>

      <section class="widgets spa-listing spa-details completed">
        <div class="widget-header">
          {props.currentWidgetObj.widgetHeaderImageUrl && (
            <div class="widget-header-img">
              <img
                src={`${CMSPath}${props.currentWidgetObj.widgetHeaderImageUrl}`}
                alt={props.currentWidgetObj.displayName}
              />
            </div>
          )}
          <div class="widget-header-title">
            {t(`spaBooking.headingSuccess`)}
          </div>
          <div class="widget-header-subtitle">
            {props.updateReservationDetails ? t(`spaBooking.sub_headingSuccessUpdated`) : t(`spaBooking.sub_headingSuccess`)}
          </div>
        </div>



        <div class="widgets">
          <div class="row margin-bottom-2">
            <div class="row">
              <div class="col">
                <div class="detail-body stay-body">
                  <div class="stay-info-details">
                    <div class="stay-info-body">

                      <p style={{ whiteSpace: "pre-line" }}>
                        {t("spaBooking.success_page_body").replace("#SPA_NAME", props.selectedService.name)}
                      </p>

                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="form-controls">
                <button
                  onClick={() => {
                    props.next();
                  }}
                >
                  {t(`spaBooking.okay`)}
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

    </>
  );
};

const mapStateToProps = (state) => {
  return {
    installedAppVersion: state.store.installedAppVersion,
    installedAppBuildNo: state.store.installedAppBuildNo,
    currentWidgetObj: state.store.sideNavBar.currentWidget,
  };
};

export default connect(
  mapStateToProps,
  {}
)(withTranslation("translations")(SpaBookingSuccess));
